<template>
  <quill-editor v-model="content"
    ref="myQuillEditor"
    :options="editorOption"
    @blur="onEditorBlur($event)"
    @focus="onEditorFocus($event)"
    @change="onEditorChange($event)"
    @ready="onEditorReady($event)">
  </quill-editor>

</template>

<script>
  // require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
  components: {
    quillEditor
  },
  name: 'Editor',

  data() {
    return {
      content: this.initialContent || '',
      editorOption: {        
        theme: 'snow'    
      }
    };
  },
  methods: {
    onEditorBlur(quill) {
      /*console.log('editor blur!', quill)*/
    },
    onEditorFocus(quill) {
      /*console.log('editor focus!', quill)*/
    },
    onEditorReady(quill) {
      /*console.log('editor ready!', quill)*/
    },
    onEditorChange({ quill, html, text }) {
      this.$emit('contentChanged', html);
    }
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
  mounted() {
    console.log('this is current quill instance object', this.editor)
  },
  props: {
    initialContent: {
      type: String,
      default () {
        return ''
      }
    }
  }
};
</script>

<style lang="css" scoped>
</style>
